// extracted by mini-css-extract-plugin
export default {"container":"Banner_container__qJzjT","container-image":"Banner_container-image__P8V1N"};